import { render } from "./MobilePanel.vue?vue&type=template&id=22b2b5f0"
import script from "./MobilePanel.vue?vue&type=script&lang=js"
export * from "./MobilePanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__